/**
 * @generated SignedSource<<dd9816ffd861779a9c32acc609a4eb6e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type NoticeDeleteInput = {
  id: string;
};
export type dashboard_noticeDeleteMutation$variables = {
  input: NoticeDeleteInput;
};
export type dashboard_noticeDeleteMutation$data = {
  readonly noticeDelete: {
    readonly id: string;
  };
};
export type dashboard_noticeDeleteMutation = {
  response: dashboard_noticeDeleteMutation$data;
  variables: dashboard_noticeDeleteMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "dashboard_noticeDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Notice",
        "kind": "LinkedField",
        "name": "noticeDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "dashboard_noticeDeleteMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Notice",
        "kind": "LinkedField",
        "name": "noticeDelete",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "filters": null,
            "handle": "deleteRecord",
            "key": "",
            "kind": "ScalarHandle",
            "name": "id"
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "0beed0388fe8a13778b15156932232d4",
    "id": null,
    "metadata": {},
    "name": "dashboard_noticeDeleteMutation",
    "operationKind": "mutation",
    "text": "mutation dashboard_noticeDeleteMutation(\n  $input: NoticeDeleteInput!\n) {\n  noticeDelete(input: $input) {\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "3f6c92c7de2f27e034ceb6a4aeecb885";

export default node;
